import { ResponseGetStoresList } from "@CommonApi/stores/list";
import { omniAtom } from "src/utils/atoms";

export const categoriesModalStoreAtom = omniAtom({
  key: "modals/categories/store",
  value: null as null | ResponseGetStoresList["data"][0],
});
